enum LinkType {
  DEFAULT = 'default',
  NOSTYLES = 'no-styles',
  PRIMARY_ARROW = 'primary-arrow',
  PRIMARY_ICON = 'primary-icon',
  SECONDARY_ICON = 'secondary-icon',
  SECONDARY_ICON_LIGHT = 'secondary-icon-light',
  INLINE = 'inline',
  INLINE_LIGHT = 'inline-light',
  DOWNLOAD = 'download',
  DOWNLOAD_NO_UNDERSCORED = 'download-no-underscored',
  EXTERNAL = 'external',
  SECONDARY_EXTERNAL = 'secondary-external',
  SECONDARY_EXTERNAL_NO_UNDERSCORE = 'secondary-external-no-underscored',
  BREADCRUMB = 'Breadcrumb',
  BREADCRUMB_NO_ICON = 'Breadcrumb-no-icon',
  VIDEO_LINK = 'video-link',
  VIDEO_LINK_NO_UNDERSCORE = 'video-link-no-underscore',
  VIDEO_LINK_LIGHT = 'video-link-light',
  MEDIA_LINK = 'media-link',
  MEDIA_LINK_LIGHT = 'media-link-light',
  FLYER_LINK = 'flyer-link',
  NAVBAR_MAIN_LINK = 'navbar-main-link',
  NAVBAR_MAIN_LINK_ACTIVE = 'navbar-main-link-active',
}

export default LinkType;
